import cx from 'clsx';

import BreakdownSection from 'features/dashboard/components/BreakdownSection';
import BreakdownSectionValues from 'features/dashboard/components/BreakdownSectionValues';
import SiteSpecificSpacesBreakdownTable from 'features/dashboard/components/SiteSpecificSpacesBreakdownTable';
import SpecialtySpacesBreakdownTable from 'features/dashboard/components/SpecialtySpacesBreakdownTable';
import WeightedSpaceBreakdownSectionTable from 'features/dashboard/components/WeightedSpaceBreakdownSectionTable';
import useSpecialtySpacesQuery from 'shared/api/specialty-spaces/useSpecialtySpacesQuery';
import { formatArea, formatNumeric } from 'utils/format';
import styles from 'theme/features/dashboard/dashboard-site-wide.module.scss';

const SiteProgramBreakdown = ({ project, overview, isCompact }) => {
  const { data: specialtySpaces } = useSpecialtySpacesQuery();

  return (
    <section className={cx(styles['program-breakdown'], isCompact && styles['program-breakdown--compact'])}>
      <h4>
        <strong>Program Breakdown</strong>
      </h4>
      <br />
      <div className={styles['program-breakdown__sections']}>
        <BreakdownSection title="Collaboration" type="collaborative" isLoading={!overview || !project}>
          <WeightedSpaceBreakdownSectionTable
            breakdown={overview?.collaborativeBreakdown}
            measurementSystem={project?.details.measurementSystem}
            withTotalSpaces
          />
        </BreakdownSection>
        <BreakdownSection title="Individual" type="individual" isLoading={!overview || !project}>
          <WeightedSpaceBreakdownSectionTable
            breakdown={overview?.individualBreakdown}
            measurementSystem={project?.details.measurementSystem}
          />
        </BreakdownSection>
        <BreakdownSection title="Community" type="community" isLoading={!overview || !project}>
          <BreakdownSectionValues
            values={[
              ['Seats', formatNumeric(overview?.communityBreakdown.seats)],
              [
                'Wellness Area',
                formatArea(overview?.communityBreakdown.wellnessArea, project?.details.measurementSystem)
              ],
              ['Cafe Area', formatArea(overview?.communityBreakdown.cafeArea, project?.details.measurementSystem)],
              ['Total Area', formatArea(overview?.communityBreakdown.totalArea, project?.details.measurementSystem)]
            ]}
          />
        </BreakdownSection>
        <BreakdownSection title="Support" type="support" isLoading={!overview || !project}>
          <BreakdownSectionValues
            values={[['Area', formatArea(overview?.supportBreakdown.area, project?.details.measurementSystem)]]}
          />
        </BreakdownSection>
        <BreakdownSection
          title="Specialty Spaces"
          type="specialty"
          isLoading={!specialtySpaces || !overview || !project}
        >
          <SpecialtySpacesBreakdownTable
            specialtySpaces={specialtySpaces ?? []}
            breakdown={overview?.specialtySpacesBreakdown ?? []}
            projectSpecialtySpaces={project?.specialtySpaces}
            measurementSystem={project?.details.measurementSystem}
          />
        </BreakdownSection>
        <BreakdownSection title="Site-Specific Spaces" type="site-specific" isLoading={!project}>
          <SiteSpecificSpacesBreakdownTable
            siteSpecificSpaces={project?.siteSpecificSpaces ?? []}
            measurementSystem={project?.details.measurementSystem}
          />
        </BreakdownSection>
      </div>
    </section>
  );
};

export default SiteProgramBreakdown;
